import axios from 'axios';

// Marketing › Tu competencia. Instancia propia de axios (un 403 de este módulo no cierra la sesión).
// En local: REACT_APP_COMPETENCIA_API_URL=http://localhost:8095 (npm run competencia:dev en el backend).
const BASE = (process.env.REACT_APP_COMPETENCIA_API_URL || process.env.REACT_APP_BACKEND_URL || 'http://localhost:8081').replace(/\/$/, '');

const api = axios.create({ baseURL: `${BASE}/api/competencia` });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('authLisualToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const errorMsg = (e) => e?.response?.data?.message || e?.message || 'Algo salió mal';

export const competencia = {
  ver: (customerId) => api.get('/', { params: { customerId } }).then((r) => r.data),
  guardar: (customerId, propia, competidores) => api.put('/', { customerId, propia, competidores }).then((r) => r.data),
};
